module.exports = __webpack_public_path__ + "static/media/paper-plane.fc1753da.png";